export enum Routes {
  HOME = '/home',
  RISKS = '/risks',
  ADMIN = '/admin',
  LOGIN = '/login',
  CLUSTERS = '/clusters',
  SETTINGS = '/settings',
  DASHBOARD = '/dashboard',
  WORKFLOWS = '/workflows',
  ACTIVITIES = '/activities',
  APPS_STORE = '/apps-store',
  CATEGORIES = '/categories',
  IDENTITIES = '/identities',
  SAAS_GRAPH = '/saas-graph',
  AUDIT_LOGS = '/audit-logs',
  AUTH_ERROR = '/auth-error',
  ATTACK_PATH = '/attack-path',
  OAUTH_ERROR = '/oauth-error',
  TOKEN_LOGIN = '/token-login',
  APPLICATIONS = '/applications',
  SET_PASSWORD = '/set-password',
  EXTERNAL_LINK = '/external-link',
  DATA_INVENTORY = '/data-inventory',
  FORGOT_PASSWORD = '/forgot-password',
  RISK_ASSESSMENT = '/risk-assessment',
  THIRD_PARTY_APPS = '/third-party-apps',
  ACCOUNT_SELECTION = '/account-selection',
}
